import classNames from 'classnames'
import { companySelector, companyAddressSelector } from 'settings/selectors'

import styles from '../styles/footer.module.scss'

const $InfoStrip = ({ company, companyAddress }) => (
    <>
        <p>{`${company}  ${new Date().getFullYear()}`}</p>
        <p>
            <T>copyright.text</T>
        </p>
        <p>{companyAddress}</p>
    </>
)

const mapStateToProps = createStructuredSelector({
    company: companySelector,
    companyAddress: companyAddressSelector,
})

export const InfoStrip = connect(mapStateToProps)($InfoStrip)

export default function FooterInfoStrip() {
    return (
        <div className={classNames('container-fluid', styles.footerStripContainer, 'text-small')}>
            <InfoStrip />
        </div>
    )
}
